const FNV_OFFSET_BASIS = 2166136261;
const FNV_PRIME = 16777619;

// FNV-1a over the characters of the id: row ids differ in a few trailing characters, and this spreads that small difference across all 32 bits so neighbouring projects do not get neighbouring covers.
export const hashCoverSeed = (seedText: string): number => {
  let hash = FNV_OFFSET_BASIS;
  for (let index = 0; index < seedText.length; index += 1) {
    hash ^= seedText.charCodeAt(index);
    hash = Math.imul(hash, FNV_PRIME);
  }
  return hash >>> 0;
};
